import { useState, useMemo, useEffect } from "react";
import { API_URL } from "../../constants/api";
import ProductCard from "./ProductCard";

export default function ProductSection({ products, cart, onAdd }) {
  const [selectedMain, setSelectedMain] = useState(null);
  const [selectedSub, setSelectedSub] = useState(null);
console.log('products:',products)
  // Main Categories
  const mainCategories = useMemo(() => {
    return [...new Set(products.map(p => p.MainCategory))];
  }, [products]);

  // Auto select first main category
  useEffect(() => {
    if (mainCategories.length && !selectedMain) {
      // setSelectedMain(mainCategories[0]);
    }
  }, [mainCategories]);

  // Sub Categories
  const subCategories = useMemo(() => {
    if (!selectedMain) return [];
    return [
     
      ...new Set(
        products
          .filter(p => p.MainCategory === selectedMain)
          .map(p => p.Category)
      ),
    ];
  }, [products, selectedMain]);

  // Filtered Products
  const filteredProducts = useMemo(() => {
    return products.filter(p => {
      if (selectedMain && p.MainCategory !== selectedMain) return false;
      if (selectedSub  && p.Category !== selectedSub)
        return false;
      return true;
    });
  }, [products, selectedMain, selectedSub]);

  return (
    <div className="container-fluid" >
      
      {/* MAIN CATEGORY TABS */}
  <ul className="nav nav-tabs mb-3 border-0 gap-2">
  {mainCategories.map(main => (
    <li className="nav-item" key={main}>
      <button
        className={`nav-link rounded-pill px-3 py-2 fw-semibold shadow-sm ${
          selectedMain === main
            ? "active bg-primary text-white border-0"
            : "bg-light text-dark border"
        }`}
        onClick={() => {
          setSelectedMain(main);
          setSelectedSub();
        }}
      >
        {main}
      </button>
    </li>
  ))}
</ul>

      {/* SUB CATEGORY PILLS */}
  <ul className="nav nav-pills mb-4 gap-2">
  {subCategories.map(sub => (
    <li className="nav-item" key={sub}>
      <button
        className={`nav-link rounded-pill px-3 py-1 small fw-medium shadow-sm ${
          selectedSub === sub
            ? "active bg-dark text-white border-0"
            : "bg-white text-dark border"
        }`}
        onClick={() => setSelectedSub(sub)}
      >
        {sub}
      </button>
    </li>
  ))}
</ul>

      {/* PRODUCT GRID */}
      <div className="row g-3">
        {filteredProducts.map(product => (
        //   <div
        //     key={product.ID}
        //     className="col-6 col-sm-4 col-md-3 col-lg-2"
        //   >
        //     <div className="card h-100 text-center shadow-sm">
        //       <img
        //         src={
        //           product.Image
        //             ? `${API_URL}/${product.Image}`
        //             : `${API_URL}/${product.Image2}`
        //         }
        //         className="card-img-top"
        //         alt={product.Name}
        //         style={{ height: 120, objectFit: "cover" }}
        //       />
        //       <div className="card-body p-2">
        //         <h6 className="card-title">{product.Name}</h6>
        //         <h5 className="card-title">${product.Price}</h5>
                
        //         <button
        //           className="btn btn-primary btn-sm w-100"
        //           onClick={() => onAdd(product)}
        //         >
        //           Add
        //         </button>
        //       </div>
        //     </div>
        //   </div>
        <ProductCard  key={product.ID} product={product} cart={cart} onAdd={onAdd} />
        ))}
      </div>
    </div>
  );
}